import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import DailyBoard from './components/DailyBoard';
import LanguageSwitcher from './components/LanguageSwitcher';
import { LanguageProvider } from './context/LanguageContext';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900">
          <LanguageSwitcher />
          <Routes>
            <Route path="/" element={<DailyBoard />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;